import {useState, useEffect, useMemo} from "react";
import {useSelector} from "react-redux";
import {useFirestoreConnect, isLoaded} from "react-redux-firebase";
import firebase from '../../src/config/firebaseConfig'

export default function useRoles() {
    const [loading, setLoading] = useState(true);
    // const userid = firebase.auth()?.currentUser.uid
    // console.log(userid)
    const getData = useSelector(state => state.firestore.ordered['roles']);

    // console.log(getData)

    const roles = useMemo(() => getData || [], [getData])

    // console.log('getData', roles)

    useEffect(() => setLoading(!isLoaded(getData)), [getData])

    useFirestoreConnect(()=>[
        {collection:'roles', storeAs: 'roles'}
    ]);
    
    // console.log('test' , getData)

     const userid = firebase.auth()?.currentUser?.uid 

    //  const userinfo = firebase.auth()?.currentUser

    // console.log(" Hooo " + JSON.stringify(roles));
    // console.log(" Hooo " + JSON.stringify(userinfo));
    // console.log(" Hooo " + JSON.stringify(firebase.auth()?.currentUser?.email));
    // console.log(" Hooo ", firebase.auth()?.currentUser?.displayName);

    const userRole = roles.find(e => e?.id === userid)

    // console.log('', JSON.stringify(userRole));

    return {roles, userRole, loading}
}
